export enum TerminationGeneratorEnum {
  Example = 'Przykład',
  Next = 'Dalej',
  OnlineRedirectModalContinueButton = 'Kontynuuj generowanie wypowiedzenia PDF',
  OnlineRedirectModalFooterText = 'Twoje dane są bezpieczne, nigdy nie będą zbierane ani nie zostaną sprzedane do celów marketingowych.',
  OnlineRedirectModalHeading = 'Szybszy sposób na wypowiedzenie umowy',
  OnlineRedirectModalIconBox1 = 'Całkowicie online',
  OnlineRedirectModalIconBox2 = 'Bez generowania dokumentów',
  OnlineRedirectModalIconBox3 = 'Zajmuje tylko kilka minut',
  OnlineRedirectModalRedirectButton = 'Przejdź do ubezpieczyciela',
  OnlineRedirectModalText1 = 'Złóż wypowiedzenie bezpośrednio u ubezpieczyciela online',
  OnlineRedirectModalText2 = '— bez dokumentów, drukowania i podpisów.',
  Section1 = 'Ubezpieczony:',
  Section2 = 'Dotyczy polisy:',
  SelectInsurer = 'Wskaż ubezpieczyciela, do którego chcesz złożyć wypowiedzenie OC.',
  SuccessModalAction = 'Rozumiem',
  SuccessModalBox1Subtitle = 'w swojej skrzynce',
  SuccessModalBox1Title = 'Otwórz wiadomość',
  SuccessModalBox2Subtitle = '(plik PDF)',
  SuccessModalBox2Title = 'Pobierz dokument',
  SuccessModalBox3Subtitle = 'własnoręcznie',
  SuccessModalBox3Title = 'Wydrukuj i podpisz',
  SuccessModalBox4Subtitle = 'ubezpieczyciela',
  SuccessModalBox4Title = 'Wyślij do',
  SuccessModalBoxesTitle = 'Co musisz zrobić?',
  SuccessModalHeading = 'Sprawdź swoją skrzynkę e-mail',
  SuccessModalMessage1 = 'E-mail powinien dotrzeć w ciągu kilku minut. Sprawdź folder ',
  SuccessModalMessage2 = 'SPAM',
  SuccessModalMessage3 = ' lub ',
  SuccessModalMessage4 = 'Oferty.',
  SuccessModalText1 = 'Wysłaliśmy do Ciebie dokumenty wypowiedzenia. Aby wypowiedzenie ',
  SuccessModalText2 = 'było ważne',
  SuccessModalText3 = ', wykonaj jeszcze poniższe kroki.',
  TerminationDocumentInfo = 'Dokument pobrany z mubi.pl',
  TerminationNoticeDate = 'Wskaż dzień, w którym chcesz zakończyć polisę poprzedniego właściciela.',
  TerminationPreviewLabel1 = 'miejscowość, data',
  TerminationPreviewLabel2 = 'nazwa zakładu ubezpieczeń',
  TerminationPreviewLabel3 = 'adres zakładu ubezpieczeń',
  TerminationPreviewLabel4 = 'imię i nazwisko ubezpieczonego',
  TerminationPreviewLabel5 = 'ulica, nr domu, mieszkania/lokalu',
  TerminationPreviewLabel6 = 'kod pocztowy, miejscowość',
  TerminationPreviewLabel7 = 'marka, model pojazdu',
  TerminationPreviewLabel8 = 'nr rejestracyjny',
  TerminationPreviewLabel9 = 'nr polisy',
  TerminationSignature = 'data, podpis',
}

export enum TerminationReasonEnum {
  Article28 = 'article28',
  Article28a = 'article28a',
  Article31 = 'article31',
}
